import React, {useState} from 'react'

import ProductsTable from "../components/products.table.component"
import ProductsForm from '../components/productform.compontent';

function ProductsScreen(){
    const [showProductForm, setShowProductForm] = useState(false);
    const [productDetails, setProductDetails] = useState({});
    
    if(showProductForm){
        return(
            <>
                <ProductsForm productDetails={productDetails}/>
            </>
        );
    }

    return(
        <ProductsTable setShowProductForm={setShowProductForm} setProductDetails={setProductDetails}/>
    );
}

export default ProductsScreen